/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */

import { requestCurrentCloudHostingIfNotRequested } from 'state/current-cloud-hosting/actions';
import { getCurrentCloudHosting, requestingCurrentCloudHosting } from 'state/current-cloud-hosting/selectors';
import CloudHostingPlanLoader from './cloud-hosting-plan-loader';
import Icon from 'components/icon';
import Money from 'components/money';
import PlanName from 'components/plan-name';
import DateTime from 'components/date-time';
import Coupon from 'components/coupon';
import { Stack, Box, Divider, Text } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import SubscriptionStatus from 'components/subscription-status';
import Card from 'components/card';
import AddOnName from 'components/addon-name';

/**
 * Style dependencies
 */
import './styles.scss';

const CurrentCloudHostngPlanCard = (props) => {
	let currentCloudHosting = props.currentCloudHosting;

	useEffect(() => {
		props.requestCurrentCloudHosting();
	}, []);

	//console.log("current cloud hosting: "+JSON.stringify(currentCloudHosting));

	if (!currentCloudHosting && !props.requesting) {
		return (
			<Card>
				<Card.Header heading='Plan details' />
				<Stack>
					<Card.Section>
						<DetailListItem label='Plan amount' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Current billing period' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Next billing date' />
					</Card.Section>
				</Stack>
			</Card>
		);
	}

	if (!currentCloudHosting && props.requesting) {
		return <CloudHostingPlanLoader />;
	}

	return (
		<Stack space='xxlarge'>
				
		    {currentCloudHosting.map((hosting) => {
		    	return (<Card><Stack><Card.Section>
							<Box display='flex' padding='small' alignItems='center'>
								<Stack space='small'>
									<Box>
										<PlanName value={hosting.subscription.plan_id} />
									</Box>
									<Box>
										Price: <Money value={hosting.subscription.plan_unit_price / 100} /> /{' '}
										{hosting.subscription.billing_period} {hosting.subscription.billing_period_unit}
						         	</Box>
						         	{hosting.subscription.status == 'active' && (
						         	<Box>
									    Next Billing On <DateTime date={hosting.subscription.next_billing_at} />
						         	</Box>
						         	)}

						         	{hosting.subscription.coupons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Discounts
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{hosting.subscription.coupons.map(({ coupon_id }) => {
													return (
														<Box key={coupon_id}>
															<Coupon couponId={coupon_id}></Coupon>
														</Box>
													);
												})}
											</Stack>
										</Box>
									)}
									{hosting.subscription.addons && (
										<Box>
											<Box>
												<Text weight='medium' size='small'>
													Addons
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{hosting.subscription.addons.map(({ unit_price, quantity, amount, id }) => {
													return (
														<Box
															key={id}
															display='flex'
															alignItems='center'
															justifyContent='spaceBetween'
														>
															<Text size='small' padding='small'>
															    <AddOnName value={id} /> {' '}
																<Money value={amount / 100} /> (<Money value={unit_price / 100} /> x {quantity})
															</Text>
														</Box>
													);
												})}
											</Stack>
										</Box>
								
								    )}
									<Box>
										<SubscriptionStatus status={hosting.subscription.status} />
									</Box>
									{hosting.subscription.status == 'future' && (
									<Box>
										Subscription start date: 
										{<DateTime date={hosting.subscription.start_date} format='Do MMM, YYYY' />}
						         	</Box>
						         	)}
						         	
								</Stack>
							</Box>

						</Card.Section></Stack></Card>)
		    })}
			
		</Stack>
	);
};

export default connect(
	(state) => ({
		currentCloudHosting: getCurrentCloudHosting(state),
		requesting: requestingCurrentCloudHosting(state),
	}),
	{
		requestCurrentCloudHosting: requestCurrentCloudHostingIfNotRequested,
	},
)(CurrentCloudHostngPlanCard);
